import React, { useState, useEffect } from 'react';
import { useActivityContext } from '../index';

const CompetencyProfilePage2 = () => {
  const { activity } = useActivityContext();
  const [profileData, setProfileData] = useState({ sensitivity: {}, creativity: {} });

  const initializeAbility = () => ({
    grade_9: { B: false, P: false, A: false },
    grade_10: { B: false, P: false, A: false },
    grade_11: { B: false, P: false, A: false },
    grade_12: { B: false, P: false, A: false }
  });

  useEffect(() => {
    if (activity?.competency_profile?.page_1) {
      setProfileData({
        sensitivity: activity.competency_profile.page_1.sensitivity || {},
        creativity: activity.competency_profile.page_1.creativity || {}
      });
    } else {
      const sensitivityAbilities = [
        'collaboration_teamwork', 'ethical_moral_reasoning', 'human_constitutional_values',
        'gender_sensitivity', 'citizenship_skills', 'fundamental_duties'
      ];
      const creativityAbilities = [
        'scientific_temper', 'creativity_innovativeness', 'sense_aesthetics_art',
        'critical_thinking', 'problem_solving', 'skills_training', 'coding_computational'
      ];

      const sensitivity = {};
      sensitivityAbilities.forEach(ability => { sensitivity[ability] = initializeAbility(); });

      const creativity = {};
      creativityAbilities.forEach(ability => { creativity[ability] = initializeAbility(); });

      setProfileData({ sensitivity, creativity });
    }
  }, [activity]);

  const sensitivityAbilities = [
    { key: 'collaboration_teamwork', label: 'Collaboration and\\nteamwork' },
    { key: 'ethical_moral_reasoning', label: 'Ethical and moral\\nreasoning' },
    { key: 'human_constitutional_values', label: 'Knowledge and\\npractice of human\\nand Constitutional\\nvalues' },
    { key: 'gender_sensitivity', label: 'Gender sensitivity' },
    { key: 'citizenship_skills', label: 'Citizenship skills\\nand values' },
    { key: 'fundamental_duties', label: 'Fundamental duties' }
  ];

  const creativityAbilities = [
    { key: 'scientific_temper', label: 'Scientific temper\\nand evidence-based\\nthinking' },
    { key: 'creativity_innovativeness', label: 'Creativity and\\ninnovativeness' },
    { key: 'sense_aesthetics_art', label: 'Sense of aesthetics\\nand art' },
    { key: 'critical_thinking', label: 'Critical thinking' },
    { key: 'problem_solving', label: 'Problem-solving' },
    { key: 'skills_training', label: 'Skills training' },
    { key: 'coding_computational', label: 'Coding and\\ncomputational\\nthinking' }
  ];

  const grades = [
    { key: 'grade_9', label: 'GRADE - 9', bgColor: '#A8D08D' },
    { key: 'grade_10', label: 'GRADE - 10', bgColor: '#9DC3E6' },
    { key: 'grade_11', label: 'GRADE - 11', bgColor: '#FFD966' },
    { key: 'grade_12', label: 'GRADE - 12', bgColor: '#F4B183' }
  ];

  const renderAbilityRow = (section, ability, index) => {
    const abilityData = profileData[section]?.[ability.key] || initializeAbility();
    const rowBg = index % 2 === 0 ? '#F2F2F2' : '#FFFFFF';

    return (
      <tr key={ability.key} style={{ backgroundColor: rowBg }}>
        <td style={{
          padding: '12px 15px',
          fontSize: '15px',
          color: 'white',
          backgroundColor: '#4472C4',
          border: '1px solid #2C3E50',
          whiteSpace: 'pre-line',
          lineHeight: '1.4',
          verticalAlign: 'top'
        }}>
          {String.fromCharCode(97 + index)}) {ability.label}
        </td>
        {grades.map(grade => (
          <React.Fragment key={grade.key}>
            {['B', 'P', 'A'].map(level => (
              <td key={level} style={{
                padding: '8px',
                textAlign: 'center',
                backgroundColor: grade.bgColor,
                border: '1px solid #999',
                width: '50px'
              }}>
                {abilityData[grade.key]?.[level] && (
                  <div style={{
                    width: '20px',
                    height: '20px',
                    margin: '0 auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#333'
                  }}>
                    ✓
                  </div>
                )}
              </td>
            ))}
          </React.Fragment>
        ))}
      </tr>
    );
  };

  return (
    <div style={{
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '40px',
      backgroundColor: 'white',
      fontFamily: "'Poppins', Arial, sans-serif",
      position: 'relative',
      boxSizing: 'border-box'
    }}>
      {/* Top-right orange corner */}
      

      {/* Table - Section 2: SENSITIVITY */}
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        border: '2px solid #2C3E50',
        marginBottom: '30px'
      }}>
        <thead>
          <tr>
            <th rowSpan={2} style={{
              padding: '15px',
              textAlign: 'center',
              fontSize: '16px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#1E3A5F',
              border: '1px solid #2C3E50',
              width: '250px'
            }}>
              ABILITIES
            </th>
            <th colSpan={12} style={{
              padding: '12px',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#2C4A6F',
              border: '1px solid #2C3E50'
            }}>
              Performance Level Descriptors
            </th>
          </tr>
          <tr>
            {grades.map(grade => (
              <th key={grade.key} colSpan={3} style={{
                padding: '10px',
                textAlign: 'center',
                fontSize: '15px',
                fontWeight: 'bold',
                color: '#333',
                backgroundColor: grade.bgColor,
                border: '1px solid #999'
              }}>
                {grade.label}
              </th>
            ))}
          </tr>
          <tr style={{ backgroundColor: '#E7E6E6' }}>
            <th style={{
              padding: '10px',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#4472C4',
              border: '1px solid #2C3E50'
            }}>
              2. SENSITIVITY
            </th>
            {grades.map(grade => (
              <React.Fragment key={grade.key}>
                {['B', 'P', 'A'].map(level => (
                  <th key={level} style={{
                    padding: '8px',
                    textAlign: 'center',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#333',
                    backgroundColor: '#E7E6E6',
                    border: '1px solid #999'
                  }}>
                    {level}
                  </th>
                ))}
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {sensitivityAbilities.map((ability, index) => renderAbilityRow('sensitivity', ability, index))}
        </tbody>
      </table>

      {/* Table - Section 3: CREATIVITY */}
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        border: '2px solid #2C3E50',
        marginBottom: '40px'
      }}>
        <thead>
          <tr style={{ backgroundColor: '#E7E6E6' }}>
            <th style={{
              padding: '10px',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#4472C4',
              border: '1px solid #2C3E50',
              width: '250px'
            }}>
              3. CREATIVITY
            </th>
            {grades.map(grade => (
              <React.Fragment key={grade.key}>
                {['B', 'P', 'A'].map(level => (
                  <th key={level} style={{
                    padding: '8px',
                    textAlign: 'center',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#333',
                    backgroundColor: '#E7E6E6',
                    border: '1px solid #999'
                  }}>
                    {level}
                  </th>
                ))}
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {creativityAbilities.map((ability, index) => renderAbilityRow('creativity', ability, index))}
        </tbody>
      </table>

      {!activity?.competency_profile?.page_1 && (
        <div style={{
          backgroundColor: '#FFF9E6',
          border: '2px dashed #F4CD8A',
          borderRadius: '8px',
          padding: '20px',
          textAlign: 'center',
          color: '#666',
          fontSize: '14px',
          marginTop: '20px'
        }}>
          <p>Your teacher has not yet completed your competency profile assessment.</p>
        </div>
      )}

      {/* Page Number */}
      <div style={{
        textAlign: 'center',
        fontSize: '14px',
        color: '#666',
        fontWeight: 'bold',
        marginTop: '30px'
      }}>
        2
      </div>

      {/* Bottom-left orange corner */}
      

      {/* Bottom-right decorative corner */}
      
    </div>
  );
};

export default CompetencyProfilePage2;
